import { format, parseISO } from 'date-fns';

export const convertISOToNotificationsDate = (date) =>
  date ? format(parseISO(date), 'LLL dd, yyyy @ p') : '';
